import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { FileUpload } from '../notify-users/file-upload';


@Component({
  selector: 'app-preview-notification-email',
  imports: [],
  templateUrl: './preview-notification-email.component.html',
  styleUrl: './preview-notification-email.component.css'
})
export class PreviewNotificationEmailComponent  implements OnInit {
  emailBody: string;
  emailSubject: string;
  attachments: FileUpload[]=[];

  constructor(    private bsModalRef: BsModalRef,
      private options: ModalOptions,
    private sanitizer: DomSanitizer){

  }
  ngOnInit(): void {
    this.emailBody = this.convertUnknownToString(this.options?.initialState?.emailBody);
    const emailFooter = "<br><br>TMSS 2.0 URL: <a href='https://tmss.gsa.gov'>https://tmss.gsa.gov</a> <br>Technical Support Assistance:<br>1 (866) 668-3472<br>gsatmsshelp@gsa.gov<br>"
    this.emailBody = this.emailBody.replace(/\n/g,'<br>');
    this.emailBody += emailFooter;
   this.sanitizer.bypassSecurityTrustHtml(this.emailBody);
   this.emailSubject = "Email Subject: " + this.emailSubject;
   console.log(this.options?.initialState);
    // this.attachments = this.options?.initialState?.attachments ?? [];

     this.attachments = Array.isArray(this.options?.initialState?.attachments) ? this.options?.initialState.attachments : [];
   console.log(this.emailBody)
 }

  convertUnknownToString(value: unknown): string {
    if (typeof value === 'string') {
      return value;
    }
    if (value === null || typeof value === 'undefined') {
      return ;
    }
    return String(value);
  }

  closeModal() {
    this.bsModalRef.hide();

  }
}
